// Lib
import React from 'react';

// Components
import Image from '../../../Image';

// Styles
import { useStyles } from './RemovedProductStyles';

const RemovedProduct = ({ product }) => {
  const { classes } = useStyles();

  const { image_link: image, product_description: description } = product || {};

  return (
    <div className={classes.root}>
      <div className={classes.imageContainer}>
        <Image
          alt="productImage"
          src={image}
          data-testid="removed-product-image"
        />
      </div>
      <div className={classes.description} data-testid="removed-product-name">
        {description}
      </div>
    </div>
  );
};

export default RemovedProduct;
